import './preprocessObsidian';
import './preprocessObsidianFgTerrain';
import { useRef } from 'react';
import { useAsset } from '@artica/assets';
import BrandedShapes from './BrandedShapes';
import Sphere from './Sphere';
import ObsidianHeroMaterial from './ObsidianHeroMaterial';

export default function ObsidianContents() {
  const group = useRef();
  const { nodes, materials } = useAsset('obsidian');

  return (
    <group
      ref={ group }
      dispose={ null }
    >
      <mesh
        name="Slab_Artica_L"
        geometry={ nodes.Slab_Artica_L.geometry }
        position={ [88.66, 21.22, 39.3] }
        rotation={ [Math.PI, -0.84, Math.PI] }
        scale={ 10 }
      >
        <ObsidianHeroMaterial
          map={ materials.Obsidian.map }
          normalMap={ materials.Obsidian.normalMap }
        />
      </mesh>
      <mesh
        name="Slab_Artica_R"
        geometry={ nodes.Slab_Artica_R.geometry }
        position={ [768.78, 38.88, 980.63] }
        rotation={ [Math.PI, -0.84, Math.PI] }
        scale={ 10 }
      >
        <ObsidianHeroMaterial
          map={ materials.Obsidian.map }
          normalMap={ materials.Obsidian.normalMap }
        />
      </mesh>
      <BrandedShapes />
      <Sphere
        nodes={ nodes }
      />
      <mesh
        name="Figure"
        geometry={ nodes.Figure.geometry }
        material={ materials.M_Woman_Winter_2 }
        position={ [-61.82, 20.59, -18.28] }
        rotation={ [Math.PI, -1.3, Math.PI] }
      />
      <mesh
        name="Mountain_BG"
        geometry={ nodes.Mountain_BG.geometry }
        material={ materials.Mtn }
        rotation={ [-2.99, 1.02, 2.91] }
        scale={ 1 }
      />
      <mesh
        name="SC3_Landscape_HQ"
        geometry={ nodes.SC3_Landscape_HQ.geometry }
        material={ materials.landscape_fg }
        position={ [63.72, 24.38, 22.27] }
        rotation={ [0.3, 1.53, -0.3] }
        scale={ 0.81 }
      />
    </group>
  );
};